/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React from 'react';
import PropTypes from 'prop-types';

import './Dropdown.scss';

/**
 * @description Dropdown
 *
 * @param {object} props - Component props
 *
 * @returns {<Dropdown />}
 */
class Dropdown extends React.Component {
  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  dropdownListItems() {
    const intViewportHeight = window.innerHeight;
    const dropdownSuggestions =
      intViewportHeight <= 480 ? this.props.predictions.slice(0, 3) : this.props.predictions;

    return dropdownSuggestions.map((prediction, i) => (
      <li
        key={i}
        onMouseDown={e => e.preventDefault()}
        onMouseUp={e => this.props.handleItemClick(e)}
        className={
          this.props.selected && this.props.selected.textContent === prediction
            ? 'autocomplete--selected'
            : ''
        }
      >
        <i className="dropdown-item--icon tsla-icon-pin" />
        {prediction}
      </li>
    ));
  }

  renderDropdownList() {
    return (
      <ul id="autocomplete" className={this.props.style}>
        {this.dropdownListItems()}
      </ul>
    );
  }

  render() {
    return <React.Fragment>{this.renderDropdownList()}</React.Fragment>;
  }
}

Dropdown.propTypes = {
  style: PropTypes.string.isRequired,
  handleItemClick: PropTypes.func.isRequired,
  selected: PropTypes.objectOf(PropTypes.object),
  predictions: PropTypes.arrayOf(PropTypes.string),
};

Dropdown.defaultProps = {
  predictions: [],
  selected: {},
};
export default Dropdown;
